export default __webpack_public_path__ + "static/media/bmw.50a70e83.png";